<div class="page">
    <div class="container">
        <div class="top_area">
            <div class="item row row_ai_center">
                <app-filter-btn></app-filter-btn>
                <a routerLink="/orders/create-orders" class="btn dark_btn row fz_s fw_500">Создать заказ <span
                        class="material-symbols-outlined fz_m">
                        add</span></a>
            </div>
            <app-filter (applyFilter)="onFilterApply($event)"
                    (resetFilter)="onFilterReset()" [filterData]="orderFilter" *ngIf="activeFilter">
                <app-filter-order (filterChanged)="onFilterChanged($event)" [orderFilter]="orderFilter" [orderFilter]="orderFilter"></app-filter-order>
            </app-filter>
        </div>
        <app-table [isLoading]="isLoading" [path]="'orders'" [dataMissing]="dataMissing" [getStatus]="getOrderStatuses" [data]="orders" [columns]="columns" [pagination]="{
                currentPage: currentPage,
                pageSize: pageSize,
                totalItems: totalItems
            }"
            (pageChange)="onPageChange($event)"><app-skeleton *ngIf="isLoading" height="40" margin="15" [count]="12"></app-skeleton></app-table>
    </div>
</div>
<app-toastr></app-toastr>